// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"95398086","119":"43a9622d","129":"99c4b0b8","381":"9229e2a3","509":"04e454e2","620":"39cce528","721":"2baae89c","773":"7d8f25f5","775":"3524d50f","836":"b6a60424","949":"8478c375"}[chunkId] + ".chunk.js";
};